<div #popUpContainer class="web-help-container">
    <h1 mat-dialog-title>
        <img src="../../../../../assets/images/wfdss/wfdss_logo_only.svg" alt="WFDSS Help Site">
        <span style="margin-left: 0.5rem">WFDSS Help</span>
    </h1>
    <div mat-dialog-content>
        <iframe [src]="safeURL" width="100%" height="100%" frameborder="0"></iframe>
    </div>
    <div>
        <button class="primary-button close-btn"
                mat-flat-button
                (click)="onClose()">Close</button>
    </div>
</div>
